module.exports = __webpack_public_path__ + "static/media/repeat-1-alt.36e84c6e.svg";